import { createActions, handleActions } from 'redux-actions';

import * as loadingState from '@coconut/constants/loadingState';

export const types = {
  SEND_GTM_EVENT: 'SEND_GTM_EVENT',
  SEND_GTM_EVENT_SUCCESS: 'SEND_GTM_EVENT_SUCCESS',
  SEND_GTM_EVENT_ERROR: 'SEND_GTM_EVENT_ERROR',
};

export const { sendGtmEvent, sendGtmEventSuccess, sendGtmEventError } =
  createActions(
    {
      [types.SEND_GTM_EVENT]: (eventName) => ({
        eventName,
      }),
      [types.SEND_GTM_EVENT_ERROR]: (error) => ({
        error,
      }),
    },
    types.SEND_GTM_EVENT_SUCCESS
  );

const INIT_STATE = {
  lastEvent: '',
  error: '',
  status: loadingState.EMPTY,
};

const reducer = handleActions(
  {
    [types.SEND_GTM_EVENT]: (state, action) => ({
      ...state,
      status: loadingState.LOADING,
      lastEvent: action.payload.eventName,
    }),
    [types.SEND_GTM_EVENT_SUCCESS]: (state) => ({
      ...state,
      status: loadingState.READY,
    }),
    [types.SEND_GTM_EVENT_ERROR]: (state, action) => ({
      ...state,
      status: loadingState.ERROR,
      error: action.payload.error,
    }),
  },
  INIT_STATE
);

export default reducer;



// WEBPACK FOOTER //
// ./src/services/redux/googleTagManager.js